//#region Imports
import { createAction, props } from '@ngrx/store';
import {
    BusinessInformationName,
    BusinessInformationPhone,
    BusinessInformationEmail,
    BusinessInformationAddress,
    WritableBusinessInformation,
} from './../../interfaces/business-information';

//#region Actions ids

enum BusinessInfoFormActions {
    loadBusinessInfoForm = '[Business Info Form] Load Business Info Form',
    resetBusinessInfoForm = '[Business Info Form] Reset Business Info Form',
    resetBusinessInfoAddress = '[Business Info Form] Reset Business Info Address',
    resetBusinessInfoEmail = '[Business Info Form] Reset Business Info Email',
    resetBusinessInfoName = '[Business Info Form] Reset Business Info Name',
    resetBusinessInfoPhone = '[Business Info Form] Reset Business Info Phone',
    resetSubmittingBusinessInfo = '[Business Info Form] Reset Submitting Business Info Form',
    setBusinessInfoForm = '[Business Info Form] Set Business Info Form',
    setBusinessInfoFormAddress = '[Business Info Form] Set Business Info Form Address',
    setBusinessInfoFormEmail = '[Business Info Form] Set Business Info Form Email',
    setBusinessInfoFormName = '[Business Info Form] Set Business Info Form Name',
    setBusinessInfoFormPhone = '[Business Info Form] Set Business Info Form Phone',
    setSubmittingBusinessInfo = '[Business Info Form] Set Submitting Business Info Form',
    setSubmittingBusinessInfoError = '[Business Info Form] Set Submitting Business Info Error Form',
}

//#region Actions Instances

export const LoadBusinessInfoFormAction = createAction(
    BusinessInfoFormActions.loadBusinessInfoForm
);

export const ResetBusinessInfoFormAction = createAction(
    BusinessInfoFormActions.resetBusinessInfoForm
);

export const ResetBusinessInfoAddressAction = createAction(
    BusinessInfoFormActions.resetBusinessInfoAddress
);

export const ResetBusinessInfoEmailAction = createAction(
    BusinessInfoFormActions.resetBusinessInfoEmail
);

export const ResetBusinessInfoNameAction = createAction(
    BusinessInfoFormActions.resetBusinessInfoName
);

export const ResetBusinessInfoPhoneAction = createAction(
    BusinessInfoFormActions.resetBusinessInfoPhone
);

export const ResetSubmittingBusinessInfoAction = createAction(
    BusinessInfoFormActions.resetSubmittingBusinessInfo
);

export const SetBusinessInfoFormAction = createAction(
    BusinessInfoFormActions.setBusinessInfoForm,
    props<WritableBusinessInformation>()
);

export const SetBusinessInfoFormAddressAction = createAction(
    BusinessInfoFormActions.setBusinessInfoFormAddress,
    props<BusinessInformationAddress>()
);

export const SetBusinessInfoFormEmailAction = createAction(
    BusinessInfoFormActions.setBusinessInfoFormEmail,
    props<BusinessInformationEmail>()
);

export const SetBusinessInfoFormNameAction = createAction(
    BusinessInfoFormActions.setBusinessInfoFormName,
    props<BusinessInformationName>()
);

export const SetBusinessInfoFormPhoneAction = createAction(
    BusinessInfoFormActions.setBusinessInfoFormPhone,
    props<BusinessInformationPhone>()
);

export const SetSubmittingBusinessInfoAction = createAction(
    BusinessInfoFormActions.setSubmittingBusinessInfo
);

export const SetSubmittingBusinessInfoErrorAction = createAction(
    BusinessInfoFormActions.setSubmittingBusinessInfoError
);